export default __webpack_public_path__ + "static/media/teak_wood.71cfe106.png";